var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 1.25,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "pen-to-square-regular",
    d: "M17.36,6.089l.476.476a.941.941,0,0,1,0,1.334L16.69,9.049,14.876,7.235l1.145-1.146a.941.941,0,0,1,1.334,0Zm-9.1,7.767,5.283-5.287,1.815,1.815-5.287,5.283a.942.942,0,0,1-.409.24l-2.3.657.657-2.3a.942.942,0,0,1,.24-.409Zm6.428-9.1L6.92,12.517a2.812,2.812,0,0,0-.72,1.224L5.074,17.678a.945.945,0,0,0,1.169,1.169l3.936-1.126A2.844,2.844,0,0,0,11.4,17L19.17,9.238a2.834,2.834,0,0,0,0-4.007l-.476-.476A2.834,2.834,0,0,0,14.687,4.755ZM3.464,6.29A3.464,3.464,0,0,0,0,9.754V20.461a3.464,3.464,0,0,0,3.464,3.464H14.171a3.464,3.464,0,0,0,3.464-3.464V16.052a.945.945,0,1,0-1.889,0v4.409a1.574,1.574,0,0,1-1.575,1.575H3.464a1.574,1.574,0,0,1-1.575-1.575V9.754A1.574,1.574,0,0,1,3.464,8.179H7.873a.945.945,0,0,0,0-1.889Z",
    transform: "translate(0 -3.925)",
    fill: "#686868"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.6b9ef27b30895d68cdaa14d2d38ce82d.svg";
export { ForwardRef as ReactComponent };